export enum RegistrationTask {
    // basic, minimal mandatory inputs to initialize registration
    EnterEmail,
    EnterTemporaryPassword,
    EnterDetails,
}

export enum RegistrationFlow {
    Free = "free",
    Paid = "paid",
    Invited = "invited",
    Returning = "returning",
}
